import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1bf131d2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1bf131d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf131d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf131d2')) {
      api.createRecord('1bf131d2', component.options)
    } else {
      api.reload('1bf131d2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1bf131d2&scoped=true&", function () {
      api.rerender('1bf131d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homeCard/buyer/tradeBoard/index.vue"
export default component.exports